import { FlexCol } from '@components'
import { DataCompletenessItem } from './DataCompletenessItem'
import { VirtualizedDataCompletenessItemsList } from './VirtualizedDataCompletenessItemsList'
import type { DataCompletenessScope } from './dataCompleteness.mapper'
import {
  type IDataCompletenessItem,
  VIRTUALIZATION_THRESHOLD,
  completenessIndicatorLayout,
  itemsScrollContainerStyle,
} from './dataCompletenessIndicator.utils'

interface DataCompletenessItemsListProps {
  items: IDataCompletenessItem[]
  scope: DataCompletenessScope
}

export const DataCompletenessItemsList = ({ items, scope }: DataCompletenessItemsListProps) => {
  if (items.length > VIRTUALIZATION_THRESHOLD) {
    return <VirtualizedDataCompletenessItemsList items={items} scope={scope} />
  }

  return (
    <FlexCol gap={`${completenessIndicatorLayout.itemRowGapPx}px`} {...itemsScrollContainerStyle}>
      {items.map(item => (
        <DataCompletenessItem key={item.id} item={item} scope={scope} />
      ))}
    </FlexCol>
  )
}
